export default function generateDisplayName(component) {
  var displayName = component.displayName || component.name;

  if (displayName) {
    return 'Fela' + displayName;
  }

  return 'ConnectedFelaComponent';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/es/bindings/generateDisplayName.js
// module id = 718
// module chunks = 0